<template>
  <div class="modal__actions flex__row">
    <div class="flex__row flex--100 flex--middle">
      <padding direction="left" size="medium-large">
        <Button type="solid" colour="grey" text-colour="secondary" @click="$emit('cancel')">
          {{ cancelButtonLabel }}
        </Button>
      </padding>
    </div>
    <div class="flex__column">
      <action-button v-if="!hideSubmit"
                     :icon="submitButtonIcon"
                     :colour="submitButtonColour"
                     :disabled="submitDisabled"
                     async-submit
                     @click="$emit('submit', $event)">
        {{ submitButtonLabel }}
      </action-button>
    </div>
  </div>
</template>

<script>
import Button from './Buttons/Button'
import ActionButton from './Buttons/ActionButton'
import Padding from './Utils/Padding'

export default {
  name: 'ModalActions',
  components: { Padding, ActionButton, Button },
  props: {
    submitButtonLabel: {
      type: String,
      required: false,
      default: 'Submit',
    },
    submitButtonIcon: {
      type: String,
      required: false,
      default: null,
    },
    submitButtonColour: {
      type: String,
      required: false,
      default: 'primary',
    },
    cancelButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel',
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
